// extracted by mini-css-extract-plugin
export var container = "_1v-0";